// extracted by mini-css-extract-plugin
export default {"container":"zUc2C","img":"j04iI","link":"YlsQK"};